define(["require", "exports", "jquery", "knockout", "log", "../../utils/urls", "../../utils/tools", "../../utils/kendoUtils", "../../shared/dataLogs", "../../models/AccountManagerModel", "../../models/UserContext", "../../utils/LookupDataSources", "../../models/ManagerDeleteModel"], function (require, exports, $, ko, log, urls_1, tools, KendoUtils, DataLogs, AccountManagerModel, UserContext, LookupDataSources, ManagerDeleteModel) {
    "use strict";
    var AccountManagers = /** @class */ (function () {
        function AccountManagers() {
            this.editModel = ko.observable(new AccountManagerModel());
            this.deleteManagerModel = ko.observable(new ManagerDeleteModel());
            this.clearFilterInProgress = false;
            this.filterByAny = ko.observable("");
        }
        AccountManagers.prototype.init = function () {
            var self = this;
            $("#page-title").text("Account Managers");
            tools.ajaxGet({
                url: "/AccountManager/GetAccountManagersLookupData",
                success: function (data) {
                    if (data.Success) {
                        self.lookupLists = data.Data.lookupLists;
                    }
                    else {
                        log.error(data.Error);
                    }
                    self.initAccountManagers(self.lookupLists.GridStructures.AccountManagerStructure);
                    ko.applyBindings(self, document.getElementById("main-container"));
                    $("#contextLoader").hide();
                    $("#mainContext").show();
                }
            });
        };
        AccountManagers.prototype.initAccountManagers = function (gridStructure) {
            var self = this;
            var columns = gridStructure.columns;
            columns.push({
                field: "",
                title: "",
                width: "100px",
                sortable: false,
                template: function (dataItem) {
                    var html = "";
                    html += '<div style="text-align:center"><a class="btn btn-info btn-edit btn-sm" title="Edit" href="#"><i class="fa fa-edit " ></i></a>';
                    html += '&nbsp;<a class="btn btn-danger btn-remove btn-sm" title="Delete" href="#"><i class="fa fa-trash-o"></i></a></div>';
                    return html;
                }
            });
            var gridId = "accountManagersTable";
            self.AccountManagerTable = new KendoUtils.KendoUtils();
            var gridOptions = {
                gridOptions: {
                    columns: columns,
                    autoBind: true,
                    resizable: true,
                    //reorderable: true,
                    //mobile: true,
                    scrollable: true,
                    columnMenu: true,
                    filterable: {
                        mode: "row menu",
                        extra: false
                    }
                },
                dataSourceOptions: {
                    transport: {
                        read: {
                            url: "/AccountManager/GetAccountManagers",
                            type: "POST",
                            dataType: "json"
                        }
                    },
                    schema: {
                        model: gridStructure.model,
                        data: function (response) { return response.Data; },
                        total: "Total"
                    }
                },
                gridId: gridId,
                showPagerOnTop: false,
                enableExport: {
                    entityName: "AccountManager",
                    title: "Account Managers",
                    enablePdf: false
                },
                autoHeight: {
                    totalOffset: 46 + 41 + 3
                },
                controller: self
            };
            self.AccountManagerTable.initGrid(gridOptions);
            self.filterByAny.extend({ rateLimit: 200 }).subscribe(function () {
                self.AccountManagerTable.refresh();
            });
            $("#" + gridId + " tbody").on("click", ".btn-edit", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.editAccountManager(data.Id);
                event.preventDefault();
            }).on("click", ".btn-remove", function (event) {
                var data = KendoUtils.KendoUtils.getGridRowDataItem(this);
                self.deleteAccountManagerConfirm(data.Id, data.Name);
                event.preventDefault();
            });
        };
        AccountManagers.prototype.editAccountManager = function (id) {
            var self = this;
            var title = id > 0 ? "Edit Account Manager" : "Add Account Manager";
            tools.editModal({
                title: title,
                buttonTitle: "Save",
                type: "info",
                modalOptions: {},
                save: function (event, modal) {
                    //validate form
                    if (!self.editModel().Name()) {
                        tools.error("Name is required");
                        return;
                    }
                    $(event.currentTarget).button("loading");
                    self.saveAccountManager(event.currentTarget, modal);
                },
                opened: function (modal) {
                    var getModelCall = null;
                    if (!isNaN(id)) {
                        getModelCall = tools.ajaxGet({
                            url: "/AccountManager/GetAccountManagerById",
                            data: { id: id },
                            success: function (result) {
                                if (result.Success) {
                                    self.editModel(new AccountManagerModel(result.Data));
                                }
                                else {
                                    log.error(result.Error);
                                }
                            }
                        });
                    }
                    else {
                        self.editModel(new AccountManagerModel());
                    }
                    $.when(getModelCall).done(function () {
                        $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'account-manager-edit-template', data: editModel }\"></div>");
                        ko.applyBindings(self, modal);
                    });
                }
            });
        };
        AccountManagers.prototype.saveAccountManager = function (btn, modal) {
            var _this = this;
            var self = this;
            var obj = ko.mapping.toJS(self.editModel);
            obj["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/AccountManager/SaveAccountManager",
                data: obj
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Changes updated successfully");
                    _this.AccountManagerTable.refresh();
                    $(modal).modal("hide");
                    return;
                }
                else {
                    tools.error(result.Error);
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        AccountManagers.prototype.deleteAccountManagerConfirm = function (id, name) {
            var self = this;
            self.deleteManagerModel(new ManagerDeleteModel());
            self.deleteManagerModel().Id(id);
            self.deleteManagerModel().Name(name);
            self.deleteManagerModel().DeleteLabel("Are you sure you want to delete Account Manager?");
            self.deleteManagerModel().NewCustomerLabel("New Account Manager For Customers");
            tools.editModal({
                title: "Delete Account Manager - ".concat(name),
                buttonTitle: "Delete",
                type: "danger",
                modalOptions: {},
                save: function (event, modal) {
                    $(event.currentTarget).button("loading");
                    self.deleteAccountManager(event.currentTarget, modal);
                },
                opened: function (modal) {
                    $(modal).find(".modal-body").html("<div data-bind=\"template: { name: 'manager-remove-template', data: deleteManagerModel }\"></div>");
                    ko.applyBindings(self, modal);
                    var lookupDataSources = new LookupDataSources();
                    var dataSource = lookupDataSources.createLookupDataSource("AccountManagers");
                    self.newAccountManagerId = $("input[name=NewId]", modal).kendoDropDownList({
                        dataSource: dataSource,
                        optionLabel: "Select Account Manager",
                        dataTextField: "Text",
                        dataValueField: "Id",
                        valuePrimitive: true,
                        filter: "contains",
                        popup: {
                            appendTo: modal
                        }
                    }).data("kendoDropDownList");
                }
            });
        };
        AccountManagers.prototype.deleteAccountManager = function (btn, modal) {
            var self = this;
            var data = {
                id: self.deleteManagerModel().Id(),
                newId: self.newAccountManagerId.value()
            };
            data["__RequestVerificationToken"] = $('#mainAntiForgeryTokenForm input[name="__RequestVerificationToken"]').val();
            tools.ajaxPost({
                url: "/AccountManager/DeleteAccountManagerConfirmed",
                data: data
            }).done(function (result) {
                if (result.Success) {
                    tools.success("Account manager deleted successfully");
                    self.AccountManagerTable.refresh();
                    $(modal).modal("hide");
                }
            }).always(function () {
                $(btn).button("reset");
            });
        };
        AccountManagers.prototype.clearFilter = function () {
            var self = this;
            self.filterByAny("");
        };
        AccountManagers.prototype.exportTo = function () {
            var self = this;
            self.AccountManagerTable.exportTo();
        };
        AccountManagers.prototype.initLogs = function () {
            if (UserContext.hasAccess("Admin")) {
                var dataLogs = new DataLogs("AccountManager");
                dataLogs.initKendoLogs("divLogsTable");
            }
        };
        return AccountManagers;
    }());
    setTimeout(function () {
        if (urls_1.urls.startsWith("/AccountManager/Index")) {
            log.log("Initialize Account Managers");
            $(function () {
                (new AccountManagers()).init();
            });
        }
    }, 0);
    return AccountManagers;
});
//# sourceMappingURL=accountManagers.js.map


//////////////////
// WEBPACK FOOTER
// ./build/areas/settings/accountManagers.js
// module id = 232
// module chunks = 2